const defaultMappedRole: Record<string, string> = {
  guest: 'Guest',
  exParent: 'ExParent',
  exStudent: 'ExStudent',
  currentParent: 'Parent',
  currentStudent: 'Student',
  counsellor: 'Counsellor',
  teacher: 'Teacher',
  coordinator: 'Coordinator',
  sectionChief: 'Section Chief',
  principal: 'Principal',
  seniorPrincipal: 'Senior Principal',
  moderator: 'Moderator',
  admin: 'Admin',
  vicePrincipal: 'Vice Principal',
  schoolOffice: 'School Office',
  contentCreator: 'Interesting Posts',
  headOfSchool: 'HOS',
  deputyHeadOfSchool: 'DHOS',
  centralAcademicTeam: 'Central Academic Team',
  nurse: 'Nurse',
  etherBot: 'Fee related posts',
  etherEventsBot: 'Event related posts',
  superAdmin: 'Super Admin',
  ancillaryStaff: 'Ancillary Staff'
};

export { defaultMappedRole };
